<template>
  <v-app>
    <loading :active.sync="busy"/>

    <div class="container">

      <!-- Header -->
      <header-simple></header-simple>

      <!-- Contents: is_confirmed -->
      <div class="contents" v-if="is_confirmed&&!success">
        <div class="header-title">
          비밀번호 재설정하기
        </div>
        <v-form>
          <div class="input-field">
            <div class="input-label">
              <span>{{ $t('change_password.password') }}</span>
              <span class="required">*</span>
            </div>
            <v-text-field
              outlined flat
              v-model.lazy="password"
              type="password"
              @change="resetError"
              @blur="$v.password.$touch()"
              :rules="passwordErrors">
            </v-text-field>
          </div>
          <!-- password_re -->
          <div class="input-field">
            <div class="input-label">
              <span>{{ $t('change_password.password_re') }}</span>
              <span class="required">*</span>
            </div>
            <v-text-field
              outlined flat
              v-model.lazy="password_re"
              type="password"
              @change="resetError"
              @blur="$v.password_re.$touch()"
              :rules="passwordReErrors">
            </v-text-field>
          </div>
        </v-form>

        <!-- error message -->
        <div class="message-error" v-if="error">
          {{ $t('change_password.try_again') }}
        </div>

        <div class="actions">
          <v-btn block depressed color="primary" 
            @click="resetPassword()">
            {{ $t('change_password.confirm') }}
          </v-btn>
        </div>
      </div>

      <!-- contents: success -->
      <div class="contents" v-if="success">
        <div class="header-title">
          비밀번호가 정상적으로 변경되었습니다.
        </div>
        <div class="actions">
          <router-link tag="div" class="btn"
            :to="{name: 'lab'}">
            <v-btn block depressed color="primary">
              랩으로 이동하기
            </v-btn>
          </router-link>
        </div>
      </div>

      <!-- contents: is_expired -->
      <div class="contents" v-if="is_expired">
        <div class="header-title">
          토큰이 유효하지 않습니다.
        </div>
        <div class="header-sub-title">
          메일을 다시 전송해주시기 바랍니다.
        </div>
        <div class="actions">
          <v-btn block depressed color="primary"
            @click="resendEmail()">
            메일 다시 전송하기
          </v-btn>
        </div>
      </div>

    </div>
  </v-app>
</template>

<script>
import { required, minLength, maxLength, sameAs } from 'vuelidate/lib/validators'

export default {
  metaInfo() {
    return {
      title: "Password Reset"
    }
  },

  data() {
    return {
      busy: false,
      password: "",
      password_re: "",
      is_confirmed: false,
      is_expired: false,
      success: false,
      error: false,
    }
  },

  computed: {
    token() {
      return this.$route.query.token
    },

    passwordErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('This field is required.')
      !this.$v.password.goodPassword && errors.push('Password must contain 8-31 characters with at least one upper-case, one lower-case, and one number')
      return errors
    },

    passwordReErrors() {
      const errors = []
      if (!this.$v.password_re.$dirty) return errors
      !this.$v.password_re.required && errors.push('Password is required.')
      !this.$v.password_re.sameAs && errors.push('Password must be same as upper one.')
      return errors
    },
  },

  validations: {
    password: {
      required,
      goodPassword(password) {
        return /[a-z]/.test(password) &&
        /[0-9]/.test(password) &&
        password.length >= 8 && password.length < 31
      }
    },
    password_re: {
      required,
      sameAs: sameAs('password')
    },
  },

  async created() {
    this.password = ""
    this.password_re = ""
    try {
      await this.$store.dispatch('confirm/checkResetPasswordToken', {
        token: this.token
      })
    } 
    catch(e) { this.is_expired = true }
    finally {
      if (!this.is_expired) { this.is_confirmed = true }
    }
  },

  methods: {
    resetError() {
      if (this.error) {
        this.error = false
      }
    },

    async resetPassword() {
      this.busy = true
      this.$v.$touch()
      if (!this.$v.$anyError) {
        try {
          await this.$store.dispatch('auth/resetPassword', {
            token: this.token,
            password: this.password
          })
        } 
        catch(e) { this.error = true }
        finally {
          if(!this.error) { this.success = true }
          this.busy = false
        }
      }
    },

    resendEmail() {
      let access_token = this.$store.getters['auth/access_token']
      if (!!access_token) {
        this.$router.replace({name: 'account'})
      } else {
        this.$router.replace({name: 'login', query: {step: 'forgot-password'}})
      }
    },
  },
}
</script>

<style scoped>

  .container {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .contents {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    max-width: 450px;
    width: 100%;
    border: 1px solid #dadce0;
    border-radius: 8px;
    padding: 22px 40px 38px;
    margin-top: 120px;
  }

  .header-title {
    padding: 20px 0;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
  }

  .header-sub-title {
    padding-bottom: 20px;
    text-align: center;
  }

</style>


// WEBPACK FOOTER //
// src/components/spa/common/PasswordReset.vue